import React from 'react';
import styled, { css } from 'styled-components';

const BaseButton = styled.button`
    height: 40px;
    min-height: 40px;
    width: 100%;
    border: none;
    border-radius: 4px;
    cursor: ${p => p.disabled ? 'default' : 'pointer'};
`;

const PrimaryButton = styled(BaseButton)`
    padding: 0 4px;
    color: ${p => p.theme.white};
    font-size: ${p => p.theme.fontSize.large};
    font-weight: ${p => p.theme.fontWeight.medium};
    ${p => !p.disabled && css`
        background: linear-gradient(
            180deg,
            ${p => p.theme.primaryLight} 0%,
            ${p => p.theme.primary} 100%
        );
    `};
    ${p => p.disabled && css`
        background-color: ${p => p.theme.pattensBlue};
    `}
`;

const IconButton = styled(BaseButton)`
    width: 40px;
    padding: 4px;
    background-color: transparent;
    color: ${p => p.theme.text};
`;

export const Button = ({
    icon,
    loading,
    disabled,
    onClick = () => {},
    children,
    ...props
}) => {
    const ButtonComponent = icon ? IconButton : PrimaryButton;
    
    return (
        <ButtonComponent
            disabled={disabled}
            onClick={onClick}
            {...props}
        >
            {children}
        </ButtonComponent>
    );
};
